import CustomTable from "Component/CustomTable";
import { useState, useEffect, useRef, useMemo } from "react";
import { Notify } from "Component/Notify";
import { fetchApi } from "Config/fetchApi";
import { DraggableModal } from "Component/Modal/index";
import { TablePagination } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "Route/ConstantRoute";
import {
  displayBinaryImage,
  formatDisplayDate,
  handleError,
  handleSuccess,
} from "Helper";
import { EncryptStorage } from "encrypt-storage";
import moment from "moment";
import { getMasterGender, getMasterNationality } from "slice/masterSlice";
import { useDispatch, useSelector } from "react-redux";
import FilterCustemTable from "Component/CustomTable/filterCustemTable";
import { decryptNik } from "Config/cripto";
import { fetchImageUrl } from "Config/fetchImage";

function WatchlistHome() {
  const dispatch = useDispatch();
  const {
    datamasterGender,
    isLoadingmasterGender,
    datamasterNationality,
    isLoadingmasterNationality,
  } = useSelector((state) => state.master.master);

  const prevUuidRef = useRef(null);
  const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
  const userInfo = encryptStorage.getItem("___info");
  const permission_flag =
    userInfo?.permission_flag != undefined
      ? JSON.parse(userInfo?.permission_flag)
      : {};
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [uuid, setUuid] = useState("");
  const [detailData, setDetailData] = useState({});
  const [keywordSearch, setDataKeyword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingImage, setIsLoadingImage] = useState(false);
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState([]);
  const [dataImage, setDataImage] = useState([]);
  const isFiltersInitialized = useRef(false);
  const [headerTable] = useState([
    { label: "NIK", align: "center", key: "nik" },
    {
      label: "Nama Lengkap",
      align: "left",
      key: "full_name",
    },
    {
      label: "Jenis Kelamin",
      align: "left",
      key: "genderName",
    },
    {
      label: "Tempat Lahir",
      align: "left",
      key: "place_of_birth",
    },
    {
      label: "Kewarganegaraan",
      align: "left",
      key: "nationalityName",
    },
    {
      label: "Status Data",
      align: "center",
      key: "is_active",
      render: (val) => (val ? "Aktif" : "Tidak Aktif"),
    },
  ]);

  const [isActionTable] = useState({
    isAdd: permission_flag?.dpo?.addData || false,
    isEdit: permission_flag?.dpo?.updateData || false,
    isShow: true,
    isDelete: false,
    // isDelete: permission_flag?.dpo?.deleteData || false,
  });

  // ==================== Pengaturan Pagination ==================== //
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  // ==================== Pengaturan Pagination ==================== //

  const datafilters = useMemo(() => {
    const baseFilters = [
      {
        key: "genderId",
        label: "Jenis Kelamin",
        isLoading: false,
        options: [],
        multiple: false,
        value: null,
      },
      {
        key: "nationalityId",
        label: "Kewarganegaraan",
        isLoading: false,
        options: [],
        multiple: false,
        value: null,
      },
      {
        key: "is_active",
        label: "Status Data",
        isLoading: false,
        options:
          [
            { label: "AKTIF", value: true },
            { label: "TIDAK AKTIF", value: false },
          ] || [],
        multiple: false,
        value: null,
      },
    ];

    return baseFilters;
  }, [datamasterGender, datamasterNationality]);

  const getDataImageByUuid = async () => {
    try {
      setIsLoadingImage(true);
      const response = await fetchApi().get(
        `/watchlist/get-image-watchlist/${detailData?.uuid_person_fr}?uuidPersonFr=${detailData?.uuid_person_fr}`
      );
      const dataImage = [];

      for (const img of response?.data?.data || []) {
        const objectURL = await fetchImageUrl({
          imagePath: img?.image_path,
        });
        dataImage.push(objectURL);
      }
      // console.log(dataImage, 'dataImage')
      setDataImage(dataImage);
      setIsLoadingImage(false);
    } catch (err) {
      setDataImage([]);
      setIsLoadingImage(false);
      handleError(err);
    }
  };

  const getData = async () => {
    try {
      setIsLoading(true);
      const valueGender =
        filters[0]?.value?.value === undefined ? "" : filters[0]?.value?.value;
      const valueNationality =
        filters[1]?.value?.value === undefined ? "" : filters[1]?.value?.value;
      const valueStatus =
        filters[2]?.value?.value === undefined ? "" : filters[2]?.value?.value;

      const paramCari = `keywords=${keywordSearch}`;
      const paramPage = `page=${pageNumber}`;
      const paramSize = `size=${pageSize}`;
      const paramGender = `genderId=${valueGender}`;
      const paramNationality = `nationalityId=${valueNationality}`;
      const paramStatus = `is_active=${valueStatus}`;
      // const response = {};
      const response = await fetchApi().get(
        `/watchlist/get-list?${paramCari}&${paramGender}&${paramNationality}&${paramStatus}&${paramPage}&${paramSize}`
      );

      setData(response?.data || {});
      setPageNumber(response.data?.currentPage || 0);
      setPageSize(response.data?.size || 5);
      setIsLoading(false);
    } catch (err) {
      setData([]);

      setIsLoading(false);
      handleError(err);
    }
  };

  const deleteData = async () => {
    try {
      setIsLoading(true);
      const response = await fetchApi().delete(`/person/delete/${uuid}`);
      handleSuccess(response.data?.message);
      getData();
      setOpenModalDelete(false);
    } catch (err) {
      setOpenModalDelete(false);
      handleError(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isFiltersInitialized.current) {
      getData();
    }
  }, [keywordSearch, pageNumber, pageSize, filters]);

  useEffect(() => {
    if (
      detailData?.uuid_person_fr !== undefined &&
      detailData.uuid_person_fr !== prevUuidRef.current
    ) {
      prevUuidRef.current = detailData.uuid_person_fr;
      getDataImageByUuid();
    }
  }, [detailData]);

  useEffect(() => {
    if (
      datafilters.length > 0 &&
      datamasterGender?.length > 0 &&
      datamasterNationality?.length > 0 &&
      !isFiltersInitialized.current
    ) {
      const mapped = datafilters.map((f) => {
        let options = [];
        let isLoading = false;

        if (f.key === "genderId") {
          options = datamasterGender.map((s) => ({
            label: s?.gender_name,
            value: s?.id,
          }));
          isLoading = isLoadingmasterGender;
        } else if (f.key === "nationalityId") {
          options = datamasterNationality.map((s) => ({
            label: s?.nationality_type_name,
            value: s?.id,
          }));
          isLoading = isLoadingmasterNationality;
        } else {
          options = [
            { label: "AKTIF", value: true },
            { label: "TIDAK AKTIF", value: false },
          ];
        }

        return {
          ...f,
          value: f.multiple ? [] : null,
          options,
          isLoading,
        };
      });

      setFilters(mapped);
      isFiltersInitialized.current = true;
    }
  }, [
    datafilters,
    datamasterGender,
    datamasterNationality,
    isLoadingmasterGender,
    isLoadingmasterNationality,
  ]);

  useEffect(() => {
    dispatch(getMasterGender());
    dispatch(getMasterNationality());
  }, []);

  const handleFilterChange = (key, newValue) => {
    setFilters((prev) =>
      prev.map((f) => (f.key === key ? { ...f, value: newValue } : f))
    );
  };
  // console.log(detailData, "detailData");
  return (
    <div>
      <div className="text-lg font-bold text-start gap-2 pb-5">
        <p
          className="text-2xl font-bold"
          style={{
            fontFamily: "Poppins",
          }}
        >
          Daftar Pencarian Orang
        </p>
      </div>
      <FilterCustemTable
        filtersConfig={datafilters}
        filters={filters?.length === 0 ? datafilters : filters}
        handleFilterChange={handleFilterChange}
        sxCustem={(f) => (f?.key === "nationalityId" ? 300 : 200)}
        onClickCreate={() =>
          navigate(ROUTES.management_data.watchlist.watchlist_create)
        }
        isAction={isActionTable}
        onEditData={(data) =>
          navigate(ROUTES.management_data.watchlist.watchlist_update, {
            state: data,
          })
        }
        onClickShow={(data) => {
          setDetailData(data);
          setOpenModal(true);
        }}
        onDeleteData={(data) => {
          setUuid(data?.uuid);
          setOpenModalDelete(!openModalDelete);
        }}
        isLoading={data?.data === undefined ? true : isLoading}
        onRefresh={() => {
          setDataKeyword(keywordSearch);
          setPageSize(pageSize);
          setPageNumber(pageNumber);
        }}
        headerData={headerTable}
        Data={data.data || []}
        onSearchData={(keyword) => {
          setDataKeyword(keyword);
        }}
        rowsPerPage={pageSize}
        page={pageNumber}
        TablePagination={
          <TablePagination
            rowsPerPageOptions={[5, 15, 30, 50]}
            component="div"
            count={data?.totalItems || 0}
            rowsPerPage={pageSize}
            page={pageNumber}
            onPageChange={(event, newPage) => setPageNumber(newPage)}
            onRowsPerPageChange={(event) => {
              setPageSize(parseInt(event.target.value, 10));
              setPageNumber(0);
            }}
          />
        }
      />

      {/* Modal Detail Data */}
      <DraggableModal size="md" open={openModal} toggleModal={() => {}}>
        <DraggableModal.Header className="capitalize">
          <div className="flex gap-4 items-center justify-between">
            <p
              className="text-2xl font-bold"
              style={{
                fontFamily: "Poppins",
              }}
            >
              Detail Data
            </p>
            <button
              className="h-10 flex w-auto justify-center items-center rounded-xl hover:bg-neutral-100 px-3 py-1.5 text-xl font-semibold leading-6 text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
              onClick={() => {
                setDetailData({});
                // setDataImage([]);
                setOpenModal(!openModal);
              }}
            >
              <i className="ri-close-line"></i>
            </button>
          </div>
        </DraggableModal.Header>

        <DraggableModal.Body className="overflow-y-auto max-h-[90vh]">
          <div className="flex justify-center items-center px-5 w-full">
            <div className="w-full bg-white shadow-lg rounded-lg p-4">
              {isLoadingImage && (
                <div className="flex justify-center items-center px-5 w-full">
                  <div className="w-full rounded-lg p-4">
                    <div className="w-full flex justify-start">
                      <div className="w-full">
                        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                          {[...Array(5)].map((_, index) => (
                            <div key={index} className="relative animate-pulse">
                              <div className="w-full h-36 bg-gray-300 rounded-md"></div>
                              <div className="absolute top-1 right-1 bg-slate-300 text-white text-xs px-2 py-1 rounded-full shadow-md">
                                {index + 1}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* {!isLoadingImage && dataImage.length > 0 && (
                <div className="w-full flex justify-start">
                  <div className="w-full">
                    <div className="mt-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
                      {dataImage.map((url, index) => (
                        <div key={index} className="relative">
                          <img
                            src={displayBinaryImage(url)}
                            alt={`Preview ${index + 1}`}
                            className="w-full h-36 object-contain rounded-md"
                          />
                          <button className="absolute -top-1 right-0 bg-red-600 text-white text-xs px-2 py-1 rounded-full shadow-md hover:bg-red-700">
                            {index + 1}
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )} */}
              {!isLoadingImage && dataImage.length > 0 && (
                <div className="w-full flex justify-start">
                  <div className="w-full px-0 md:px-4">
                    <div className="max-w-screen-lg mx-auto">
                      <div className="mt-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
                        {/* Render preview images */}
                        {dataImage.map((url, index) => (
                          <div key={`preview-${index}`} className="relative">
                            <img
                              // src={displayBinaryImage(url)}
                              src={url?.url}
                              alt={`Preview ${index + 1}`}
                              className="w-full h-24 md:h-36 object-cover rounded-md shadow-md"
                            />
                            <button className="absolute -top-1 right-0 bg-red-600 text-white text-xs px-2 py-1 rounded-full shadow-md hover:bg-red-700">
                              {index + 1}
                            </button>
                          </div>
                        ))}

                        {/* Render default images for empty slots */}
                        {Array.from({ length: 5 - dataImage.length }).map(
                          (_, index) => (
                            <div
                              key={`default-${index}`}
                              className="relative border-2 rounded-md"
                            >
                              <img
                                src="/asset/defaultImg.jpeg" // Ganti dengan path gambar default Anda
                                alt="Default placeholder"
                                className="w-full h-24 md:h-36 object-cover rounded-md shadow-md opacity-50"
                              />
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {dataImage?.length === 0 && !isLoadingImage && (
                <div className="mt-4 p-4 border-2 border-dashed border-gray-300 rounded-md text-center">
                  <p className="text-gray-500">Gambar Kosong</p>
                </div>
              )}
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 py-5 px-5 w-full">
            {[
              { label: "Nama Lengkap", value: detailData?.full_name },
              { label: "NIK", value: decryptNik(detailData?.nik) },
              { label: "Tempat Lahir", value: detailData?.place_of_birth },
              {
                label: "Tanggal Lahir",
                value: formatDisplayDate(detailData?.date_of_birth),
              },
              { label: "Jenis Kelamin", value: detailData?.genderName },
              { label: "Agama", value: detailData?.religionName },
              { label: "Pekerjaan", value: detailData?.occupation },
              { label: "Kewarganegaraan", value: detailData?.nationalityName },
              { label: "Status Perkawinan", value: detailData?.maritalStatus },
              { label: "Gol Darah", value: detailData?.bloodTypeName },
              { label: "Alamat", value: detailData?.address },
              {
                label: "Kasus Kriminalitas",
                value: detailData?.caseDescription,
              },
            ].map((item, idx) => (
              <div key={idx} className="break-words">
                <label className="text-sm block font-bold leading-6 font-poppins">
                  {item.label}
                </label>
                <p className="text-md font-medium whitespace-pre-line break-words font-poppins">
                  {item.value || "-"}
                </p>
              </div>
            ))}
          </div>
        </DraggableModal.Body>

        <DraggableModal.Footer>
          <div className="flex gap-4 items-center justify-end">
            <button
              onClick={() => {
                setDetailData({});
                setDataImage([]);
                setOpenModal(!openModal);
              }}
              className="h-11 flex w-auto justify-center items-center rounded-xl bg-btn-login hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
            >
              Tutup
            </button>
          </div>
        </DraggableModal.Footer>
      </DraggableModal>

      {/* Modal Confirm Delete */}
      <DraggableModal
        size="sm-md"
        open={openModalDelete}
        toggleModal={() => {}}
      >
        <DraggableModal.Header className="capitalize">
          <div className="flex gap-4 items-center justify-between">
            <p
              className="text-2xl font-bold"
              style={{
                fontFamily: "Poppins",
              }}
            >
              Hapus Data
            </p>
            <button
              className="h-10 flex w-auto justify-center items-center rounded-xl hover:bg-neutral-100 px-3 py-1.5 text-xl font-semibold leading-6 text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
              onClick={() => setOpenModalDelete(!openModalDelete)}
            >
              <i className="ri-close-line"></i>
            </button>
          </div>
        </DraggableModal.Header>
        <DraggableModal.Body>
          <div className="w-full text-lg font-bold text-start">
            <p
              className="text-md font-medium"
              style={{
                fontFamily: "Poppins",
              }}
            >
              Apakah Anda yakin ingin menghapus data ini ?
            </p>
          </div>
        </DraggableModal.Body>
        <DraggableModal.Footer>
          <div className="flex gap-4 items-center justify-end">
            <button
              className="h-11 flex w-auto justify-center items-center rounded-xl hover:bg-neutral-100 px-3 py-1.5 text-sm font-semibold leading-6 text-black  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
              onClick={() => setOpenModalDelete(!openModalDelete)}
            >
              Tutup
            </button>
            <button
              onClick={deleteData}
              className="h-11 flex w-auto justify-center items-center rounded-xl bg-rose-900 hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
            >
              Hapus
            </button>
          </div>
        </DraggableModal.Footer>
      </DraggableModal>
    </div>
  );
}

export default WatchlistHome;
